import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import {
  mediaMax,
  calculateResponsiveSize,
  themeColor
} from '@dboxdev/ui-components'

export const ButtonLink = styled((props) => <Link {...props} />)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${calculateResponsiveSize(241)};
  height: ${calculateResponsiveSize(56)};
  padding: ${calculateResponsiveSize(10)};
  text-align: center;
  font-size: ${calculateResponsiveSize(18)};
  line-height: 1.334;
  letter-spacing: ${calculateResponsiveSize(0.432)};
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid ${themeColor('accentColor')};
  background: none;
  cursor: pointer;
  &&,
  &&:hover {
    color: ${themeColor('accentColor')};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(130)};
    height: ${calculateResponsiveSize(30)};
    padding: ${calculateResponsiveSize(6)};
    font-size: ${calculateResponsiveSize(10)};
    letter-spacing: ${calculateResponsiveSize(0.233)};
  }
`
